import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { getOperations } from '../operationsActions';
import EnhancedTableHead from './EnhancedTableHead';
import ReceptionsTableLoader from './ReceptionsTableLoader';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  }
});

/**
 * Tableau d'affichage de toutes les receptions de marchandises
 *
 * @param {Object} classes                        classes style
 * @param {{Object[]}} receptions                 Liste des receptions reçu du serveur
 * @param {Function} dispatchGetOperations        Récupération des receptions auprès du serveur
 * @param {Boolean} loading                       Indique si les requêtes sont terminer
 */

const EnhancedTable = ({
  classes,
  customerOperations,
  numberOfOperations,
  loading
}) => {
  const { search } = useLocation();
  const history = useHistory();

  const handleChangePage = (event, currentPage) => {
    history.replace({
      search: qs.stringify({
        ...qs.parse(search, { ignoreQueryPrefix: true }),
        page: +currentPage + 1
      })
    });
  };

  return (
    <div>
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead rowCount={1} loading={loading} />
            {loading ? (
              <ReceptionsTableLoader />
            ) : (
              <TableBody>
                {customerOperations.map(customerOperation => (
                  <TableRow
                    hover
                    style={{ cursor: 'pointer' }}
                    tabIndex={-1}
                    key={customerOperation.id}
                    onClick={() =>
                      history.push(`/operation/${customerOperation.id}`)
                    }
                  >
                    <TableCell align="left">{customerOperation.id}</TableCell>
                    <TableCell align="left">{customerOperation.name}</TableCell>
                    <TableCell align="left">
                      {get(customerOperation, 'operationManager.name') || '-'}
                    </TableCell>
                    <TableCell align="left">
                      {customerOperation.todoQuantity}
                    </TableCell>
                    <TableCell align="left">
                      {customerOperation.toShipQuantity}
                    </TableCell>
                    <TableCell align="left">
                      {customerOperation.shippedQuantity}
                    </TableCell>
                    <TableCell align="left">
                      {customerOperation.totalQuantity}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </div>
        <TablePagination
          disabled
          rowsPerPageOptions={[10]}
          component="div"
          count={numberOfOperations}
          rowsPerPage={8}
          page={+qs.parse(search, { ignoreQueryPrefix: true }).page - 1}
          backIconButtonProps={{
            disabled:
              loading ||
              +qs.parse(search, { ignoreQueryPrefix: true }).page === 1,
            'aria-label': 'Previous Page'
          }}
          nextIconButtonProps={{
            disabled:
              loading ||
              +qs.parse(search, { ignoreQueryPrefix: true }).page >
                numberOfOperations / 8,
            'aria-label': 'Next Page'
          }}
          onChangePage={handleChangePage}
        />
      </Paper>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchGetOperations: params => dispatch(getOperations(params))
});

const mapStateToProps = state => ({
  customerOperations: state.operations.customerOperations,
  numberOfOperations: state.operations.numberOfOperations,
  loading: state.operations.loading
});

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  customerOperations: PropTypes.array.isRequired,
  numberOfOperations: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EnhancedTable));
